import React from 'react';
import S from './StyledRegisterWizardFormStep0.js';
import Box from 'react-styled-box';
import { translation } from 'helpers/utilsHelper.js';
import FormIcon from 'form_icon.svg';
import BankIcon from 'bank_icon.svg';

const RegisterWizardFormStep0 = ({ onFormSelect, onBankSelect, isMyIdActive }) => {
    return (
        <Box flexDirection="column" alignItems="center" width="100%" padding="40px 0">
            <Box margin="0 0 30px 0">
                <S.Title>
                    {translation('registerForm_selectMethodTitle')}
                </S.Title>
            </Box>

            <S.ButtonsWrapper>
                {isMyIdActive && (
                    <S.MethodButton onClick={onBankSelect}>
                        <S.MethodContent>
                            <S.HeaderRow>
                                <S.IconBank dangerouslySetInnerHTML={{__html: BankIcon}}/>
                                <S.MethodTitle>{translation('registerForm_methodBank')}</S.MethodTitle>
                            </S.HeaderRow>
                            <S.MethodDescription>
                                {translation('registerForm_methodBankDescription')}
                            </S.MethodDescription>
                        </S.MethodContent>
                        <S.ArrowRight />
                    </S.MethodButton>
                )}

                <S.MethodButton onClick={onFormSelect}>
                    <S.MethodContent>
                        <S.HeaderRow>
                            <S.IconForm dangerouslySetInnerHTML={{__html: FormIcon}}/>
                            <S.MethodTitle>{translation('registerForm_methodForm')}</S.MethodTitle>
                        </S.HeaderRow>
                        <S.MethodDescription>
                            {translation('registerForm_methodFormDescription')}
                        </S.MethodDescription>
                    </S.MethodContent>
                    <S.ArrowRight />
                </S.MethodButton>
            </S.ButtonsWrapper>
        </Box>
    );
};

export default RegisterWizardFormStep0;